'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Bars;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Bars(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return _react2.default.createElement(
    'svg',
    {
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-failure', className),
      preserveAspectRatio: 'xMinYMin meet',
      viewBox: '0 0 1792 1792',
      xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z' })
  );
}

Bars.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Bars/Bars.js
// module id = 155
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16